// extracted by mini-css-extract-plugin
export default {"category-selection":"x5ruAX6IJYfYOKsD65j0qA==","selected":"+tQPYM-cRkOAQDKZw2UYOQ==","games":"QxxJ+tAITupfh0bso-xv6w=="};